import { ViewTagsMap } from "../models/TrendingModelsV2";

const STORAGE_PREFIX = "mesf_trending_view_v2_";

export const saveViewToLocal = (viewId: number, viewTags: ViewTagsMap) => {
	try {
		const key = `${STORAGE_PREFIX}${viewId}`;
		localStorage.setItem(key, JSON.stringify(viewTags));
	} catch (e) {
		console.error("Failed to save view to local storage", e);
	}
};

export const getViewFromLocal = (viewId: number): ViewTagsMap | null => {
	try {
		const key = `${STORAGE_PREFIX}${viewId}`;
		const data = localStorage.getItem(key);
		return data ? JSON.parse(data) : null;
	} catch (e) {
		console.error("Failed to load view from local storage", e);
		return null;
	}
};

export const removeViewFromLocal = (viewId: number) => {
	try {
		const key = `${STORAGE_PREFIX}${viewId}`;
		localStorage.removeItem(key);
	} catch (e) {
		console.error("Failed to remove view from local storage", e);
	}
};
